module.exports = __webpack_public_path__ + "static/media/biz.cb29f0dc.svg";